// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import {
  GOT_GENERAL_PROPERTIES,
  UPDATE_BOT_TRAY_CONFIG_SUCCESS,
} from '../actions/common';

const generalProperties = (state = {}, action) => {
  switch (action.type) {
    case GOT_GENERAL_PROPERTIES:
      return { ...state, ...action.props };
    case UPDATE_BOT_TRAY_CONFIG_SUCCESS:
      return {
        ...state,
        preferences: {
          agentConsoleConfig: {
            ...state.preferences.agentConsoleConfig,
            ...action.props,
          },
        },
      };
    default:
      return state;
  }
};

export default generalProperties;
